import React from 'react';
import TabellaGenerale from '../TabellaGenerale';

function AreaUnico() {
    return (
        <TabellaGenerale titolo="Area unico" url="areaunico" nome="Unico" numTabella={3} />
    );
};

export default AreaUnico;